import { InlineLoading } from "@carbon/react";

export const View = (props) => {
  return (
    <div>
      <InlineLoading {...props} />
    </div>
  );
};
